import React from 'react';


function Logo(props) {

return (
  <div className="logo">
  <img src="https://i.imgur.com/sTPT5ml.png" alt="logo" className="logo-img"></img>
    </div>
  )
}
export default Logo;